const partnerIntegrations = Object.freeze({
  KLAAR: 'partner_klaar',
  SPRING_VERIFY: 'partner_spring_verify',
  PAZCARE: 'partner_pazcare'
});

export default partnerIntegrations;
